import React, { ReactElement } from 'react'
import { ArtData } from '@/database/art'

const EmptyOverview = ({ artData }: { artData: ArtData | undefined }): ReactElement => {
    return <div className="white">Not yet implemented</div>
}

export default EmptyOverview
